import { DownloadFile, Icon, PrintFile } from '@livable/saas-react-components';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import useStyles from './styles';
const dataArray = [{
  title: 'Livable Handbooks',
  items: [{
    name: 'logo.png',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: "Bill&Collect - Residents Pay Through Livable's Portal.pdf",
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Convergent - Residents Pay You Directly.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }]
}, {
  title: 'Onboarding New Residents (Lease Addenda, Notices, etc)',
  items: [{
    name: "Bill&Collect - Residents Pay Through Livable's Portal.pdf",
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Convergent - Residents Pay You Directly.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }]
}, {
  title: 'Program Overviews + Important Dates',
  items: [{
    name: "Bill&Collect - Residents Pay Through Livable's Portal.pdf",
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Convergent - Residents Pay You Directly.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }]
}, {
  title: 'Property Manager Portal Guides',
  items: [{
    name: 'Allocation Table Section.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Appfolio ID and charges.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Appfolio ID.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Move in via the PM Portal.jpg',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Move-out and Final Statement generation process guide.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Resident Account Profile.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }]
}, {
  title: 'Resident Communication Samples',
  items: [{
    name: 'Bill & Collect Welcome Email.png',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Bill & Collect Welcome Letter Physical.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Convergent Welcome Email.png',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Net Zero Billing Statement.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Resident Portal.png',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Statement.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }]
}, {
  title: 'Video tutorials',
  items: [{
    name: 'PM Portal Intro.mp4',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: "02 How to Setup a Resident's Account.mp4",
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: "03 How to Access the Resident's Account.mp4",
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: 'Net Zero Billing Statement.pdf',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: '04 How to Access the Allocation Table.mp4',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }, {
    name: '05 Move Out Processing.mp4',
    downloadLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png"),
    previewLink: "".concat(process.env.RESOURCES_CDN_ENDPOINT, "/emailTemplates/img/logo.png")
  }]
}];
export default function LivableGuidesTab() {
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageContainer
  }, dataArray.map(data => /*#__PURE__*/React.createElement(Accordion, {
    className: classes.accordion,
    key: data.title,
    defaultExpanded: true
  }, /*#__PURE__*/React.createElement(AccordionSummary, {
    "aria-controls": "guides-details",
    id: "guides-details",
    expandIcon: /*#__PURE__*/React.createElement(Icon, {
      fontSize: "large",
      type: "arrow-line-right"
    })
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, data.title)), /*#__PURE__*/React.createElement(AccordionDetails, null, data.items.map(item => /*#__PURE__*/React.createElement("div", {
    className: classes.item,
    key: item.name
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, item.name), /*#__PURE__*/React.createElement("div", {
    className: classes.actions
  }, /*#__PURE__*/React.createElement(PrintFile, {
    href: item.downloadLink
  }), /*#__PURE__*/React.createElement(DownloadFile, {
    fileName: item.name,
    fileUrl: item.downloadLink,
    text: "file_cabinet.download"
  }))))))));
}